import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import Icon from './Icon';
import classes from './StarRating.scss';

class StarRating extends React.Component {
  static propTypes = {
    input: PropTypes.shape({
      value: PropTypes.any,
      onChange: PropTypes.func.isRequired,
    }),
    iconClass: PropTypes.string,
    activeIconClass: PropTypes.string,
    iconCount: PropTypes.number,
  };

  static defaultProps = {
    iconClass: `icon icon-review-star ${classes.star}`,
    activeIconClass: `icon icon-review-star ${classes.activeStar}`,
    iconCount: 5,
    input: undefined,
  };

  state = {
    hoverTarget: null,
  };

  handleMouseEnter = (iconIndex) => {
    this.setState({ hoverTarget: iconIndex });
  };

  handleMouseLeave = () => {
    this.setState({ hoverTarget: null });
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onChange(value);
  };

  renderIcon = (index) => {
    const { iconClass, activeIconClass, input: { value } } = this.props;
    const { hoverTarget } = this.state;

    const isActive = (hoverTarget === null ? value : hoverTarget) >= index;

    return (
      <Icon
        key={index}
        id={index}
        className={isActive ? activeIconClass : iconClass}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleChange}
      />
    );
  };

  render() {
    const { iconCount } = this.props;

    return (
      <div>
        {range(1, iconCount + 1).map(this.renderIcon)}
      </div>
    );
  }
}

export default StarRating;
